import React, { useState, useEffect } from "react";

export default function BinaryGame() {
    const [mode, setMode] = useState("decToBin"); // decToBin o binToDec
    const [number, setNumber] = useState(0);
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(45);
    const [gameActive, setGameActive] = useState(false);
    const [feedback, setFeedback] = useState("");

    const generateQuestion = () => {
        const newMode = Math.random() > 0.5 ? "decToBin" : "binToDec";
        setMode(newMode);

        if (newMode === "decToBin") {
            setNumber(Math.floor(Math.random() * 64)); // 0-63
        } else {
            const decNum = Math.floor(Math.random() * 64);
            setNumber(parseInt(decNum.toString(2))); // mostra il binario come numero
        }
        setAnswer("");
        setFeedback("");
    };

    const startGame = () => {
        setScore(0);
        setTimeLeft(45);
        setGameActive(true);
        generateQuestion();
    };

    useEffect(() => {
        if (gameActive && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && gameActive) {
            setGameActive(false);
        }
    }, [timeLeft, gameActive]);

    const checkAnswer = () => {
        let correct = "";

        if (mode === "decToBin") {
            correct = number.toString(2);
        } else {
            correct = parseInt(number.toString(), 2).toString();
        }

        if (answer === correct) {
            setScore(score + 1);
            setFeedback("✓ Corretto!");
            setTimeout(() => generateQuestion(), 800);
        } else {
            setFeedback(`✗ Era: ${correct}`);
            setTimeout(() => setFeedback(""), 1500);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && answer && gameActive) {
            checkAnswer();
        }
    };

    if (!gameActive && timeLeft > 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-binary" style={{marginRight:"6px"}}></i> Binary Challenge
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Converti tra decimale e binario!</p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (timeLeft === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Tempo Scaduto!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    Punteggio: {score}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score >= 12 && "🎉 Sei un mago del binario!"}
                    {score >= 8 && score < 12 && "👍 Ottimo! Continua a esercitarti!"}
                    {score >= 4 && score < 8 && "💪 Buon inizio!"}
                    {score < 4 && "0️⃣1️⃣ Il binario è la base di tutto!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{display:"flex", justifyContent:"space-between", marginBottom:"1rem", fontSize:"0.85rem"}}>
                <span style={{color:"#94a3b8"}}>⏱️ {timeLeft}s</span>
                <span style={{color:"#22c55e", fontWeight:"700"}}>🎯 {score} punti</span>
            </div>

            <div style={{
                padding:"0.8rem",
                background:"rgba(59,130,246,0.1)",
                borderRadius:"0.5rem",
                marginBottom:"1rem",
                border:"1px solid rgba(59,130,246,0.3)"
            }}>
                <div style={{fontSize:"0.8rem", color:"#94a3b8", marginBottom:"0.3rem"}}>
                    {mode === "decToBin" ? "Decimale → Binario" : "Binario → Decimale"}
                </div>
                <div style={{
                    fontSize:"2rem",
                    fontWeight:"700",
                    color:"#3b82f6",
                    fontFamily:"monospace"
                }}>
                    {number}
                </div>
            </div>

            <div style={{position:"relative", marginBottom:"1rem"}}>
                <input
                    type="text"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    onKeyPress={handleKeyPress}
                    autoFocus
                    pattern={mode === "decToBin" ? "[01]*" : "[0-9]*"}
                    style={{
                        width:"100%",
                        padding:"0.8rem",
                        borderRadius:"0.5rem",
                        border:"2px solid rgba(255,255,255,0.1)",
                        background:"rgba(255,255,255,0.05)",
                        color:"#fff",
                        fontSize:"1.2rem",
                        textAlign:"center",
                        outline:"none",
                        fontFamily:"monospace"
                    }}
                    placeholder={mode === "decToBin" ? "Es: 101010" : "Es: 42"}
                />
            </div>

            {feedback && (
                <div style={{
                    padding:"0.6rem",
                    background: feedback.includes("✓") ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.2)",
                    borderRadius:"0.5rem",
                    marginBottom:"1rem",
                    fontSize:"0.85rem",
                    color: feedback.includes("✓") ? "#22c55e" : "#ef4444",
                    fontWeight:"600"
                }}>
                    {feedback}
                </div>
            )}

            <button
                onClick={checkAnswer}
                disabled={!answer}
                style={{
                    background: answer ? "linear-gradient(135deg,#2563eb,#1e40af)" : "rgba(255,255,255,0.1)",
                    border:"none",
                    color:"#fff",
                    fontWeight:"700",
                    padding:"0.6rem 1.2rem",
                    borderRadius:"0.5rem",
                    cursor: answer ? "pointer" : "not-allowed",
                    opacity: answer ? 1 : 0.5,
                    width:"100%"
                }}
            >
                <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
            </button>
        </div>
    );
}